import React, { useEffect } from "react";
import DashboardComponent from "./dashboard";
import { connect } from "react-redux";
import { dashboardPresidentCount } from "../../../redux/slice/dashboardPresidentCountSlice";
import { societyComplaint } from "../../../redux/slice/societyComplaintSlice";
import { societyVisitorList } from "../../../redux/slice/societyVisitorListSlice";
import { presidentActivity } from "../../../redux/slice/presidentActivitySlice";
import PageLoader from "../common/pageLoader";
import { Cookies } from "react-cookie";

const Dashboard = (props) => {
  const {
    dashboardPresidentCountData,
    calldashboardPresidentCountData,
    societyComplaintData,
    callsocietyComplaintData,
    societyVisitorListData,
    callsocietyVisitorListData,
    presidentActivityData,
    callpresidentActivity,
  } = props;

  const loading =
    dashboardPresidentCountData.isLoading || societyComplaintData.isLoading;
  const cookies = new Cookies();

  const society_count =
    (dashboardPresidentCountData &&
      dashboardPresidentCountData?.dashboardPresidentCountData &&
      dashboardPresidentCountData?.dashboardPresidentCountData?.data) ||
    null;
  const complaintData =
    (societyComplaintData &&
      societyComplaintData?.societyComplaintData &&
      societyComplaintData?.societyComplaintData?.data &&
      societyComplaintData?.societyComplaintData?.data?.data) ||
    null;
  const visitorData =
    societyVisitorListData?.societyVisitorListData?.data || null;

  const presidentActivityDataList = presidentActivityData?.presidentActivityData?.data?.data;
  

  useEffect(() => {
    const validateToken = async () => {
      const token = cookies.get("token");

      if (token) {
        calldashboardPresidentCountData();
        callpresidentActivity();
        callsocietyVisitorListData();
        callsocietyComplaintData({
          startDate: null,
          endDate: null,
          status: null,
          societyId: null,
        });
      }
    };
    validateToken();
  }, []);

  return (
    <>
      {loading && <PageLoader />}
      <DashboardComponent
        society_count={society_count}
        complaintData={complaintData}
        visitorData={visitorData}
        presidentActivityDataList={presidentActivityDataList}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    dashboardPresidentCountData: state.dashboardPresidentCountData,
    societyComplaintData: state.societyComplaintData,
    societyVisitorListData: state.societyVisitorListData,
    presidentActivityData: state.presidentActivity,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    calldashboardPresidentCountData: () => dispatch(dashboardPresidentCount()),
    callsocietyComplaintData: (filters) => dispatch(societyComplaint(filters)),
    callsocietyVisitorListData: () => dispatch(societyVisitorList()),
    callpresidentActivity: () => dispatch(presidentActivity()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
